import { ADMIN_APP_API_PREFIX } from "./apiUtils";
import createAxiosInstance from "./axiosOptimized";

const { postRequest, delRequest } = createAxiosInstance(ADMIN_APP_API_PREFIX);

export const login = params => postRequest(`login`, params);
export const logout = params => delRequest(`logout`, params);
export const resetPassword = params => postRequest(`reset-pw`, params);
export const changePassword = params => postRequest(`set-pw`, params);
